import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import StripePaymentComponent from './components/component';
import { receivePaymentComplete } from '../../actions/stripe';
import ReturnsApolloProvider from '../ApolloProvider';
import { updateStep2Complete } from '../../actions/page';

/*
 * TODO:
 * This component contains specific usage logic,
 * migrate to the general "StripeWidget" component
 *
 * */

export const mapStateToProps = ({
  returnOptions: {
    selectedOptionMethodKey,
    returnOptionMethods: {
      [selectedOptionMethodKey]: { return_cost: { service_fee: serviceFee } = {} } = {},
    } = {},
  } = {},
  stripe: { paymentIntentSecret, publishableKey, completedPayment, errorMessage } = {},
}) => ({
  paymentIntentSecret,
  publishableKey,
  completedPayment,
  serviceFee,
  errorMessage,
});

const StyledErrors = styled.h3`
  margin: 1rem 0;
  color: #eb1c26;
  text-align: center;
`;

const StripePayment = ({
  dispatch,
  onSuccess,
  paymentIntentSecret,
  publishableKey,
  completedPayment,
  serviceFee,
  errorMessage,
}) => {
  const stripeSuccessCallback = async () => {
    dispatch(receivePaymentComplete(true));
    dispatch(updateStep2Complete(true));
    onSuccess();
  };
  if (completedPayment || !serviceFee) return null;
  if (errorMessage) {
    return (
      <StyledErrors className="card-errors" role="alert">
        {errorMessage}
      </StyledErrors>
    );
  }
  return (
    <ReturnsApolloProvider>
      <StripePaymentComponent
        paymentIntentSecret={paymentIntentSecret}
        publishableKey={publishableKey}
        onSuccess={stripeSuccessCallback}
      />
    </ReturnsApolloProvider>
  );
};

StripePayment.defaultProps = {
  onSuccess: () => {},
};

StripePayment.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  paymentIntentSecret: PropTypes.string.isRequired,
  publishableKey: PropTypes.string.isRequired,
  completedPayment: PropTypes.bool.isRequired,
  serviceFee: PropTypes.number.isRequired,
  errorMessage: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(StripePayment);
